export const CopyIcon = () => {
  return (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 0C0.447715 0 0 0.447715 0 1V11.9524C0 12.5046 0.447715 12.9524 1 12.9524H8.75C9.30228 12.9524 9.75 12.5046 9.75 11.9524V1C9.75 0.447715 9.30228 0 8.75 0H1ZM10.5625 3.04768V12.3143C10.5625 13.0875 9.9357 13.7143 9.1625 13.7143H3.25V15C3.25 15.5523 3.69771 16 4.25 16H12C12.5523 16 13 15.5523 13 15V4.04766C13 3.49537 12.5523 3.04765 12 3.04766L10.5625 3.04768Z"
        fill="#0281A7"
      />
    </svg>
  )
}
